import { jsx as _jsx } from "react/jsx-runtime";
import classnames from "classnames";
import styles from "./PopupImage.module.scss";
export const PopupImage = ({ alt = "", imageSrc, isAgeVerificationInProgress, dataTestId }) => (_jsx("div", { className: classnames(styles.wrapper, {
        [styles.wrapperBlurred]: isAgeVerificationInProgress,
    }), "data-testid": dataTestId, children: _jsx("img", { className: styles.mainImage, src: imageSrc, alt: alt, loading: "lazy" }) }));
//# sourceMappingURL=PopupImage.js.map